import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import DataActions from '../redux/dataRedux'

const id = 'InfrastructurePipelineVector'
const sourceLayer = 'InfrastructurePipelineClassification'
const authId = 'Infrastructure'
// export const URL = ({ idToken, timeIso }) =>
//   `https://coresight-vector.s3-us-west-2.amazonaws.com/InfrastructurePipeline/{z}/{x}/{y}`
// export const INFRASTRUCTURE_PIPELINE_VECTOR = ({ idToken, timeIso }) =>
//   `https://coresight-vector.s3-us-west-2.amazonaws.com/InfrastructurePipeline/{z}/{x}/{y}`
export const URL = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3AInfrastructurePipelineClassification&styles=&format=application%2Fx-protobuf;type=mapbox-vector&transparent=true&tiled=true&height=512&width=512&srs=EPSG%3A3857&BBOX={bbox-epsg-3857}&token=${idToken}`

export class InfrastructurePipelineVector extends Component {
  componentDidMount () {
    const { map } = this.context
    if (!map) { return }
    map.on('moveend', this.handleClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    map.off('moveend', this.handleClick)
  }

  handleClick = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(undefined, {
      layers: ['InfrastructurePipelineVector']
    })
    const data = features.map(feature => feature.properties)
    const _features = features.map(feature => ({ properites: feature.properties, geometry: feature._geometry }))

    actions.featuresUpdated(_features)
    actions.dataUpdated(data)
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const {
      idToken,
      layerRendered,
      time,
      uuidsSelected = [],
      paint
    } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const vectorSource = {
      type: 'vector',
      // tiles: [INFRASTRUCTURE_PIPELINE_VECTOR({ idToken, timeIso })],
      tiles: [URL({ idToken, timeIso })],
      tileSize: 512
    }

    const layout = {
      'line-join': 'round',
      'line-cap': 'round'
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />
        <Layer
          type='line'
          key={`${id}-classification`}
          id={`${id}-classification`}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={{
            // 'line-opacity': ['number', ['get', 'residential_difference']],
            // 'line-width': 10,
            'line-opacity': 1,
            'line-width': ['*', ['number', ['get', 'residential_difference']], -2],
            'line-color': 'red',
          }}
          layout={{
            'line-cap': 'square'
          }}
          />
        <Layer
          type='line'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={paint}
          layout={layout}
          />
        <Layer
          key={`${id}Selected`}
          type='line'
          sourceId={id}
          sourceLayer={sourceLayer}
          layout={{}}
          paint={{
            'line-color': 'red',
            'line-width': 10
          }}
          filter={['in', 'ogc_fid'].concat(uuidsSelected)}
        />,
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id, authId),
      paint: getPaint(state, id),
      time: state.layer.times.InfrastructurePipelineVector || undefined
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: json =>
        dispatch(DataActions.dataFulfilled(json, 'InfrastructurePipeline')),
      featuresUpdated: json =>
        dispatch(DataActions.dataFulfilled(json, 'InfrastructurePipelineFeatures'))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  InfrastructurePipelineVector
)



// WEBPACK FOOTER //
// ./src/layers/InfrastructurePipelineVector.js